import * as ReducerActions from "../actions/3dPrintingShop";

const initialState = {
    basketItemTotal: 0,
    updateBtn: false,
    items: [],
    serverQuanities: {},
    basketQuantities: {},
    basketTotal: 0,
    basketTotalWithoutDisounts: 0,
    partlyPaidItems: false,
    deals: [],
    basketSuccess: false,
    bottomButtonsOpacity: 0,
    checkoutFormData: {
        values: {
            addressLine1: "",
            addressLine2: "",
            town: "",
            postcode: "",
            tel: ""
        },
        valids: {
            addressLine1: false,
            addressLine2: false,
            town: false,
            postcode: false,
            tel: false
        },
        touched: {
            addressLine1: false,
            addressLine2: false,
            town: false,
            postcode: false,
            tel: false
        },
        wholeForm: false
    },
    postageActive: true,
    postageOptions: [],
    selectedPostage: 0,
    couponUUID: 0,
    checkoutSubTotal: 0,
    checkoutTotal: 0,
    settings: {},
    bottomFooterData: {}
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ReducerActions.UPDATE_BASKET_ITEM_TOTAL:
            return { ...state, basketItemTotal: action.value };
        case ReducerActions.UPDATE_SETUPDATE:
            return { ...state, updateBtn: action.value };
        case ReducerActions.UPDATE_BASKET:
            return {
                ...state,
                items: action.items,
                serverQuanities: action.serverQuanities,
                basketQuantities: action.basketQuantities,
                basketTotal: action.basketTotal,
                basketTotalWithoutDisounts: action.basketTotalWithoutDisounts,
                partlyPaidItems: action.partlyPaidItems,
                basketItemTotal: action.itemTotal,
                deals: action.deals
            };
        case ReducerActions.UPDATE_BASKET_QUANITIES:
            return { ...state, basketQuantities: action.value };
        case ReducerActions.TOGGLE_BASKET_SUCCUESS:
            return { ...state, basketSuccess: action.value };
        case ReducerActions.TOGGLE_BOTTOMBUTTONS_OPACITY:
            return { ...state, bottomButtonsOpacity: action.value };
        case ReducerActions.CHECKOUT_DATA_UPDATE:
            return { ...state, checkoutFormData: action.value };
        case ReducerActions.CLEAR_BASKET_INTERFACE:
            return { ...state, items: [], serverQuanities: {}, basketQuantities: {}, basketTotal: 0, basketItemTotal: 0 };
        case ReducerActions.UPDATE_POSTAGE_OPTIONS:
            return {
                ...state,
                postageOptions: action.postageOptions,
                selectedPostage: action.selectedPostage,
                postageActive: action.active,
                checkoutSubTotal: action.checkoutSubTotal,
                checkoutTotal: action.checkoutTotal
            };
        case ReducerActions.UPDATE_SELECTED_POSTAGE:
            return { ...state, selectedPostage: action.value, checkoutTotal: action.checkoutTotal };
        case ReducerActions.UPDATE_TOTALS_AFTER_COUPON:
            return { ...state, checkoutSubTotal: action.checkoutSubTotal, checkoutTotal: action.checkoutTotal, couponUUID: action.couponUUID };
        case ReducerActions.UPDATE_SETTINGS:
            return { ...state, settings: action.value };
        case ReducerActions.UPDATE_BOTTOM_FOOTER_DATA:
            return { ...state, bottomFooterData: action.value };
        default:
            return state;
    }
};

export default reducer;
